// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__PtTRk","alertIcon":"ConfirmModal_alertIcon__BD4YL"};